 import React, { useState } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";

toast.configure();
export default function Changepassword(props) {
  const [Newpassword, setNewpassword] = useState("");
  const [confirmpassword, setconfirmpassword] = useState("");
  const [password, setpassword] = useState("");

  const ChangePassword = (e) => {
    e.preventDefault();
    var demoid1 = 'demo01';
    //var demoid2 = 'demo02';
    if(props.userid.toUpperCase() === demoid1.toUpperCase()){

      toast.warn("Demo account password can't be changed", {
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }
    var strongRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,15}$/;
    var test = Newpassword.match(strongRegex);

    if (Newpassword === "" || confirmpassword === "" || password === "") {
      toast.warn("Password can not be Blank!", {
        position: toast.POSITION.TOP_CENTER,
      });
    } else if (Newpassword != confirmpassword) {
      toast.warn(" password is not matched!", {
        position: toast.POSITION.TOP_CENTER,
      });
    } else if (Newpassword === password) {
      toast.warn("Old password and new password is not same!", {
        position: toast.POSITION.TOP_CENTER,
      });
    } else if (!test) {
      toast.warn(
        "Password must have 8 to 15 alphanumeric without white space; cannot be the same as username/nickname; must contain at least 1 capital letter, small letter and numbers; and must not contain any special characters (!,@,#,etc..)",
        { position: toast.POSITION.TOP_CENTER }
      );
    } else {
      axios
        .post("https://liveapi247.live/api1/changepassword", {
          id: props.userid,
          token: props.utoken,
          newPassword: Newpassword,
          oldPassword: password,
        })
        .then((result) => {
          if (result.status === 210) {
            toast.success("Password Changed Successfully", {
              position: toast.POSITION.TOP_CENTER,
            });
          }
          if (result.status === 220) {
            toast.warn("Your old password is wrong", {
              position: toast.POSITION.TOP_CENTER,
            });
          }
        })
        .catch((e) => {
          //setIsError(true);
        });
    }
  };
  return (
    <React.Fragment>
      <div _ngcontent-lst-c69=""    id="changePasswordModal" class="pop_bg" style={{ display: "block" }}>
        <div _ngcontent-lst-c69=""    class="pop_box">
          <a _ngcontent-lst-c69=""    class="close_pop" onClick={props.handleClosepassmodel}>
            close_pop
          </a>

          <h3 _ngcontent-lst-c69=""   >Change Password</h3>

          <dl  _ngcontent-lst-c69=""   class="form_list">
            <dt _ngcontent-lst-c69=""   >New Password</dt>
            <dd _ngcontent-lst-c69=""   >
              <input _ngcontent-lst-c69=""   
                id="newPassword"
                type="password"
                value={Newpassword}
                onChange={(e) => {
                  setNewpassword(e.target.value);
                }}
                placeholder="Enter"
              />
              <span  _ngcontent-lst-c69=""   class="must">＊</span>
              <span  _ngcontent-lst-c69=""   id="newPasswordErrorText" class="error-text"></span>
            </dd>
            <dt _ngcontent-lst-c69=""   >New Password Confirm</dt>
            <dd>
              <input _ngcontent-lst-c69=""   
                id="newPasswordConfirm"
                type="password"
                value={confirmpassword}
                onChange={(e) => {
                  setconfirmpassword(e.target.value);
                }}
                placeholder="Enter"
              />
              <span _ngcontent-lst-c69=""    class="must">＊</span>
              <span  _ngcontent-lst-c69=""   id="newPasswordConfirmErrorText" class="error-text"></span>
            </dd>
            <dt _ngcontent-lst-c69=""   >Your Password</dt>
            <dd>
              <input _ngcontent-lst-c69=""   
                id="changePassword"
                type="password"
                value={password}
                onChange={(e) => {
                  setpassword(e.target.value);
                }}
                placeholder="Enter"
              />
              <span _ngcontent-lst-c69=""    class="must">＊</span>
            </dd>
            <dd>
              <a _ngcontent-lst-c69=""   
                id="changePasswordBtn"
                 
                onClick={(e) => {
                  ChangePassword(e);
                }}
                class="btn-send"
              >
                Change
              </a>
            </dd>
          </dl>
        </div>
      </div>
    </React.Fragment>
  );
}
